/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_General_SectionInputs */

const fr_settings_general_section = /** @type {(inputs: Settings_General_SectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Général`)
};

const en_settings_general_section = /** @type {(inputs: Settings_General_SectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`General`)
};

/**
* | output |
* | --- |
* | "General" |
*
* @param {Settings_General_SectionInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_general_section = /** @type {((inputs?: Settings_General_SectionInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_General_SectionInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_settings_general_section(inputs)
	return en_settings_general_section(inputs)
});